import React from 'react'
import _startCase from 'lodash/startCase'
import SortableTable from '../SortableTable'
import { getTableColumns } from '../../utils/sortableTableUtils'
import { fieldTypeOptions } from './utils/constants'

const formatTypeText = (typeText = '') => {
  if (typeof typeText !== 'string') return ''

  return typeText.replace(/[^a-zA-Z]/g, '-')
}

const CustomFieldsTable = props => {
  const { data, type, handleEditClick, handleDeleteClick } = props

  return (
    <div className="cff-sfield">
      <p style={{ fontSize: 16, fontWeight: 600 }}>{_startCase(type)} Custom Fields</p>
      {data.length ? (
        <SortableTable
          tableColumns={getTableColumns([
            {
              key: 'type',
              normalizer: value => {
                const selectedFieldType = fieldTypeOptions.find(option => option.value === value)
                return selectedFieldType?.label
              },
            },
            'label',
            'name',
            'defaultValue',
            'order'
          ])}
          data={data}
          enableCopyTable={false}
          actionsLabel="Actions"
          actions={[
            {
              label: 'Edit',
              className: 'btn btn-primary',
              icon: 'fa fa-pencil fa-fw',
              onClick: data => handleEditClick({ ...data, parentType: type }),
            },
            {
              label: 'Delete',
              className: 'btn btn-danger',
              icon: 'fa fa-trash fa-fw',
              onClick: data => handleDeleteClick({ ...data, parentType: type }),
            },
          ]}
        />
      ) : (
        <div className="text-center" style={{ backgroundColor: '#31363e', padding: 12, fontWeight: 600 }}>
          No custom fields for {formatTypeText(type)}
        </div>
      )}
    </div>
  )
}

export default CustomFieldsTable
